import { MoneyType, MoneyFormat } from "~/components/Money";
import {
  type GetClientDataQuery,
  type GetClientEntitiesQuery,
} from "~/graphql/supergraphTypes";
import { toMoneyType } from "./utils";

export type ClientArenaType = NonNullable<GetClientDataQuery["getClientData"]>["clientArena"];
export type EntityType = NonNullable<
  GetClientEntitiesQuery["getClientEntities"]
>["entities"][number];
export type QuickLinkType = NonNullable<
  GetClientDataQuery["getClientData"]
>["quickLinks"][number];

export interface SummaryItem {
  label: string;
  value: string;
  moneyValue?: MoneyType | null;
  tooltip: string;
  format?: MoneyFormat;
}

export interface TextFilter {
  filterType: "text";
  filter: string;
  type?: string;
}

export interface NumberFilter {
  filterType: "number";
  filter: number;
}

export interface DateFilter {
  filterType: "date";
  dateFrom: string;
  type?: string;
}

export interface SetFilter {
  filterType: "set";
  values: string[];
}

export interface FilterInfo {
  conditions?: Array<{ filter: string }>;
  operator?: string;
  filterType?: string;
  filter?: string | number;
  values?: string[];
  dateFrom?: string;
  type?: string;
}

export const BILLING_SUMMARY_ITEMS = (
  clientArena: ClientArenaType,
  isBillingEnableFADataFlagEnabled: boolean,
): SummaryItem[] => [
  {
    label: "Base EUM",
    value: clientArena.baseEumUsd?.toString() || "-",
    moneyValue: toMoneyType(clientArena.baseEumUsd, "USD"),
    tooltip:
      "The last contracted base EUM. For GPX, if a client's current EUM is above their base EUM, then the client will be issued a “true-up” to charge them on the new base.",
    format: MoneyFormat.Symbol,
  },
  {
    label: "Software EUM Local",
    value: clientArena.currentBlendSoftwareEumLocal?.toString() || "-",
    moneyValue: toMoneyType(clientArena.currentBlendSoftwareEumLocal, "USD"),
    tooltip: "Total aggregate billable Software EUM in local currency",
    format: MoneyFormat.Amount,
  },
  {
    label: "Software EUM USD",
    value: clientArena.currentBlendSoftwareEumUsd?.toString() || "-",
    moneyValue: toMoneyType(clientArena.currentBlendSoftwareEumUsd, "USD"),
    tooltip: "Total aggregate billable Software EUM in USD",
    format: MoneyFormat.Symbol,
  },
  ...(isBillingEnableFADataFlagEnabled
    ? [
        {
          label: "FA EUM Local",
          value: clientArena.billableFaEumLocal?.toString() || "-",
          moneyValue: toMoneyType(clientArena.billableFaEumLocal, "USD"),
          tooltip: "Total aggregate billable FA EUM in local currency",
          format: MoneyFormat.Symbol,
        },
        {
          label: "FA EUM USD",
          value: clientArena.billableFaEumUsd?.toString() || "-",
          moneyValue: toMoneyType(clientArena.billableFaEumUsd, "USD"),
          tooltip: "Total aggregate billable FA EUM in USD",
          format: MoneyFormat.Symbol,
        },
        {
          label: "Total payments",
          value: clientArena.totalPayments?.toString() || "-",
          moneyValue: toMoneyType(clientArena.totalPayments, "USD"),
          tooltip: "Year to date Payment volume ACH/Wire",
          format: MoneyFormat.Amount,
        },
      ]
    : []),
];
